// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pricing_wrapper__3UT1j","controls":"pricing_controls__VXj-5","title":"pricing_title__uc8Yn","group":"pricing_group__1W8sl","card":"pricing_card__N7pOg"};